
export default class Map_Performance {
  viewer;
  frameRate;
  isPause;

  constructor(viewer) {
    this.viewer = viewer;
    this.isPause = false;
    this.start();
  }

  start() {
    const options = {
      scene: this.viewer.scene,
      samplingWindow: 1.0, // fps calculé durant cette periode
      quietPeriod: 0.5, // wait after startup page
      warmupPeriod: 0.5, // duree du warmup
      minimumFrameRateDuringWarmup: 400, // < fps -> entree dans le warning
      minimumFrameRateAfterWarmup: 1, // > fps -> sortie du warning
      fps: 0,
    };

    this.frameRate = new Cesium.FrameRateMonitor(options);
    const eventHelper = new Cesium.EventHelper();
    eventHelper.add(
      this.frameRate.lowFrameRate,
      (scene, fps) => {
        options.fps = fps;
      }
    );
    setInterval(() => {

      if(this.isPause == false) {
        this.fpsManage(options.fps);
      }
    }, 1000);
  }

  setPause(IsPause) {

    this.isPause = IsPause;
    if(IsPause) {
      this.viewer.scene.postProcessStages.fxaa.enabled = false;
      this.viewer.scene.msaaSamples = 1;
      this.viewer.scene.globe.enableLighting = false;
      this.viewer.shadowMap.enabled = false;
      this.viewer.resolutionScale = 1.0;
      this.viewer.shadowMap.size = 1024;
      this.viewer.scene.globe.maximumScreenSpaceError = 2;
    }
  }

  fpsManage(fps) {

    //auto
    let qualityMode = $root.user.getSettingsQuality();
    //// console.log("fpsManage:" + fps + " quality: " + qualityMode);
    $root.global.fps = fps.toFixed(1);
    if (qualityMode == 0) {
      if (
        this.viewer.scene.requestRenderMode === true ||
        this.frameRate.lastFramesPerSecond === undefined
      )
        return;
      if (fps < 10) {
        if (this.viewer.resolutionScale === 0.9) return; // min

        if (this.viewer.scene.globe.maximumScreenSpaceError < 3) {
          this.viewer.scene.globe.maximumScreenSpaceError += 0.1;
        }

        this.viewer.scene.postProcessStages.fxaa.enabled = false;
        this.viewer.scene.msaaSamples = 1;
        this.viewer.shadowMap.size = 1024;

        if (this.viewer.scene.globe.maximumScreenSpaceError >= 3) {
          this.viewer.scene.globe.enableLighting = false;
          this.viewer.resolutionScale = 0.9;
          this.viewer.shadowMap.enabled = false;
        }
      } else {
        if (this.viewer.scene.globe.maximumScreenSpaceError > 2) {
          this.viewer.scene.globe.maximumScreenSpaceError -= 0.1;
        }
        this.viewer.resolutionScale = 1.0;

        if (this.viewer.scene.globe.maximumScreenSpaceError <= 2) {
          if (fps > 15) {
            this.viewer.shadowMap.enabled = false;
            this.viewer.scene.globe.enableLighting = true;
            this.viewer.scene.msaaSamples = 2;
            this.viewer.shadowMap.size = 2048;
          }
          if (fps >= 20) {
            this.viewer.scene.postProcessStages.fxaa.enabled = true;
            this.viewer.scene.msaaSamples = 4;
          }
        }
      }
    } else if (qualityMode == 1) {
      //low
      this.viewer.scene.postProcessStages.fxaa.enabled = false;
      this.viewer.scene.msaaSamples = 1;
      this.viewer.scene.globe.enableLighting = false;
      this.viewer.shadowMap.enabled = false;
      this.viewer.resolutionScale = 0.9;
      this.viewer.shadowMap.size = 1024;
      this.viewer.scene.globe.maximumScreenSpaceError = 3;
    } else if (qualityMode == 2) {
      //medium
      this.viewer.scene.postProcessStages.fxaa.enabled = false;
      this.viewer.scene.msaaSamples = 2;
      this.viewer.scene.globe.enableLighting = true;
      this.viewer.shadowMap.enabled = false;
      this.viewer.resolutionScale = 1.0;
      this.viewer.shadowMap.size = 1024;
      this.viewer.scene.globe.maximumScreenSpaceError = 2;
    } else {
      //hight
      this.viewer.scene.postProcessStages.fxaa.enabled = true;
      this.viewer.scene.msaaSamples = 4;
      this.viewer.scene.globe.enableLighting = true;
      this.viewer.shadowMap.enabled = false;
      this.viewer.resolutionScale = 1.0;
      this.viewer.shadowMap.size = 2048;
      this.viewer.scene.globe.maximumScreenSpaceError = 2;
    }
  }
}
